import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  socailLoginApi,
  userForgotPass,
  userLogin,
  userOtpVerify,
  userResetPass,
  userSignUp,
} from "../../services/api/authApis";
import { toast } from "react-toastify";
import {
  changePasswordApi,
  deleteAddressApi,
  getCustomerStaffListApi,
  gettingMyProfileApi,
  updateAddAddressApi,
  updateMyProfileApi,
  updatePreferredListProfileApi,
  updateeditAddressApi,
} from "../../services/api/myProfileApis";
const initialState = {
  user: null,
  isFetching: false,
  myprofile: null,
  prefferdStaffList: [],
  isError: false,
  isLogin: false,
  error: null,
};
export const signIn = createAsyncThunk(
  "auth/signIn",
  async (
    { values, navigate, gotoLogin, gotoJobBoard, dispatch, rememberMe },
    { rejectWithValue }
  ) => {
    try {
      const data = await userLogin(values, rememberMe);

      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      else if (data?.serverResponse?.code === 200) {
        if (gotoLogin) {
          if (gotoJobBoard) {
            navigate("/checkout");
          } else {
            navigate("/dashboard");
          }
        } else {
        }

        return data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const socailLogin = createAsyncThunk(
  "auth/socailLogin",
  async (
    { values, navigate, gotoLogin, gotoJobBoard, dispatch },
    { rejectWithValue }
  ) => {
    try {
      const data = await socailLoginApi(values);
      if (data?.serverResponse?.code !== 201) return rejectWithValue(data);
      else if (data?.serverResponse?.code === 201) {
        if (gotoLogin) {
          if (gotoJobBoard) {
            navigate("/checkout");
          } else if (!data.result.user.phoneNumber) {
            navigate("/my-profile");
            toast.warning('Please complete your profile before booking')
          }
          else {
            navigate("/dashboard");
          }
        } else {
        }

        return data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const signUp = createAsyncThunk(
  "auth/signUp",
  async (values, { rejectWithValue }) => {
    const { apiData, navigate, signUpFormik, dispatch, creatingOrder } = values;
    try {
      const userSignUpResult = await userSignUp(apiData);
      if (userSignUpResult?.serverResponse?.code !== 201) {
        return rejectWithValue(userSignUpResult);
      } else if (userSignUpResult?.serverResponse?.code === 201) {
        // if (creatingOrder) {
        let signData = { email: apiData?.email, password: apiData?.password };
        dispatch(
          signIn({
            values: signData,
            navigate: null,
            gotoLogin: false,
            gotoJobBoard: true,
            dispatch: dispatch,
          })
        );
        // } else {
        //   navigate("/login");
        //   signUpFormik.resetForm();
        // }

        return userSignUpResult;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const forgotPasswordEmail = createAsyncThunk(
  "auth/forgotPassword",
  async (values, { rejectWithValue }) => {
    const { apiData, navigate, forgotPassFormik } = values;
    try {
      const data = await userForgotPass(apiData);
      if (data?.serverResponse?.code !== 200) {
        return rejectWithValue(data);
      } else if (data?.serverResponse?.code === 200) {
        navigate && navigate("/verify-otp", { state: apiData.email });
        forgotPassFormik && forgotPassFormik.resetForm();
        toast.success(data?.serverResponse?.message);
        return data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const otpVerify = createAsyncThunk(
  "auth/verify-otp",
  async (values, { rejectWithValue }) => {
    const { apiData, navigate, verifyOtpFormik } = values;
    try {
      const data = await userOtpVerify(apiData);
      if (data?.serverResponse?.code !== 200) {
        return rejectWithValue(data);
      } else if (data?.serverResponse?.code === 200) {
        navigate && navigate("/reset-password", { state: apiData.otp });
        verifyOtpFormik && verifyOtpFormik.resetForm();
        toast.success(data?.serverResponse?.message);
        return data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async (values, { rejectWithValue }) => {
    const { apiData, navigate, paramToken } = values;

    try {
      const data = await userResetPass({
        apiData: apiData,
        paramToken: paramToken,
      });
      if (data?.serverResponse?.code !== 200) {
        return rejectWithValue(data);
      } else if (data?.serverResponse?.code === 200) {
        navigate && navigate("/login");
        toast.success("Password successfully reset");
        return data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getProfileView = createAsyncThunk(
  "auth/profile/view",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingMyProfileApi();
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateProfile = createAsyncThunk(
  "auth/profile/update",
  async (values, { rejectWithValue }) => {
    try {
      const data = await updateMyProfileApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updatePreferredListProfile = createAsyncThunk(
  "auth/profile/update/preferredList",
  async (values, { rejectWithValue }) => {
    try {
      const data = await updatePreferredListProfileApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getCustomerStaffList = createAsyncThunk(
  "auth/profile/get/customer/prefferedLists",
  async (values, { rejectWithValue }) => {
    try {
      const data = await getCustomerStaffListApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const editAddress = createAsyncThunk(
  "auth/profile/editAddress",
  async (values, { rejectWithValue }) => {
    try {
      const data = await updateeditAddressApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addAddress = createAsyncThunk(
  "auth/profile/addAddress",
  async (values, { rejectWithValue }) => {
    try {
      const data = await updateAddAddressApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteAddress = createAsyncThunk(
  "auth/profile/deleteAddress",
  async (values, { rejectWithValue }) => {
    try {
      const data = await deleteAddressApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
// Change password from my profile
export const changePassword = createAsyncThunk(
  "auth/profile/change-password",
  async (values, { rejectWithValue }) => {
    try {
      const data = await changePasswordApi(values.body);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      toast.success('Password updated successfully')
      values.setOpen(false)
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      const { user } = action.payload;
      state.user = user;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isFetching = false;
      state.myprofile = null;
      state.isError = false;
      state.isLogin = false;
      state.error = null;
    },
  },
  extraReducers: {
    [signIn.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [signIn.fulfilled]: (state, { payload }) => {
      state.isLogin = true;
      state.user = payload.result.user;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      toast.success("Logged in successfully");
      return state;
    },
    [signIn.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [socailLogin.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [socailLogin.fulfilled]: (state, { payload }) => {
      state.isLogin = true;
      state.user = payload.result.user;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      toast.success("Logged in successfully");
      return state;
    },
    [socailLogin.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [signUp.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [signUp.fulfilled]: (state, { payload }) => {
      state.isLogin = true;

      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [signUp.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [forgotPasswordEmail.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [forgotPasswordEmail.fulfilled]: (state, { payload }) => {
      state.isLogin = true;

      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [forgotPasswordEmail.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [otpVerify.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [otpVerify.fulfilled]: (state, { payload }) => {
      state.isLogin = true;

      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [otpVerify.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [resetPassword.pending]: (state) => {
      state.isFetching = true;
      state.isLogin = false;
      state.isError = false;
      return state;
    },
    [resetPassword.fulfilled]: (state, { payload }) => {
      state.isLogin = true;

      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [resetPassword.rejected]: (state, { payload }) => {
      state.isLogin = false;
      state.user = null;
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [getProfileView.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getProfileView.fulfilled]: (state, { payload }) => {
      state.myprofile = payload.result;
      state.user = payload.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [getProfileView.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [updateProfile.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [updateProfile.fulfilled]: (state, { payload }) => {
      toast.success(payload?.serverResponse?.message);
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [updateProfile.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [addAddress.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [addAddress.fulfilled]: (state, { payload }) => {
      toast.success(payload?.serverResponse?.message);
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [addAddress.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },

    [editAddress.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [editAddress.fulfilled]: (state, { payload }) => {
      toast.success(payload?.serverResponse?.message);
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [editAddress.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [deleteAddress.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [deleteAddress.fulfilled]: (state, { payload }) => {
      toast.success(payload?.serverResponse?.message);
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [deleteAddress.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },

    [getCustomerStaffList.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getCustomerStaffList.fulfilled]: (state, { payload }) => {
      state.prefferdStaffList = payload.result;
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [getCustomerStaffList.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },

    [updatePreferredListProfile.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [updatePreferredListProfile.fulfilled]: (state, { payload }) => {
      toast.success(payload?.serverResponse?.message);
      state.prefferdStaffList = [];
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      return state;
    },
    [updatePreferredListProfile.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
  },
});

// this is for dispatch
export const { updateUser, clearAuth } = authSlice.actions;

// this is for configureStore
export default authSlice.reducer;
